/**
 * Created by andrey on 24.02.2021.
 */

const QuestsConfig = {};

QuestsConfig.main = {
    wheat_3: { // deprecated
        quest: {
            type: Map2d.SPAWN,
            unit: { code: "wheat", stage: 3 }
        }
    },

    woodsource_1_0: { // deprecated
        quest: {
            type: Map2d.OPENFOG
        }
    },

    woodsource_1_1: { // deprecated
        quest: {
            type: Map2d.MINE,
            unit: { code: "woodsource", stage: 1 }
        }
    },

    wood_1: { // deprecated
        quest: {
            type: Map2d.MINE,
            unit: { code: "woodsource", stage: 1 }
        }
    },

    openfog_3: {
        trigger: { unit: { code: "woodchest", stage: 0 } },
        quest: {
            type: Map2d.OPENFOG
        }
    },

    wood_2: {
        trigger: { unit: { code: "wood", stage: 1 } },
        tutorial: "wood_2",
        quest: {
            type: Map2d.BUILD,
            unit: { code: "wood", stage: 2 }
        }
    },

    candies_4: {
        trigger: { unit: { code: "candies", stage: 4 } },

        quest: {
            type: Map2d.HARVEST,
            unit: { code: "candies", stage: 4 }
        }
    },

    wheat_4: {
        trigger: { unit: { code: "wood", stage: 8 } },

        quest: {
            type: Map2d.HARVEST,
            unit: { code: "wheat", stage: 4 }
        }
    },

    dragonisland_1: {
        trigger: { unit: { code: "king", stage: 3 } },
        dynamic: {
            filter: function () {
                return Families.dragonmine && cleverapps.unitsLibrary && !cleverapps.unitsLibrary.isOpened({ code: "dragonmine", stage: 0 });
            },
            getIcon: function () {
                return UnitView.getUnitImage({ code: "dragonmine", stage: 0 }, { alignAnchorX: true });
            }
        },
        quest: {
            type: Map2d.OPENDRAGON
        }
    },

    kraken_0: { // deprecated
        dynamic: {
            filter: function () {
                const mission = cleverapps.missionManager.findByType(Mission.TYPE_KRAKENFEAST);
                return mission && mission.isRunning();
            },
            getTitle: function () {
                return Messages.get("Quest.kraken_0.title");
            },
            getIcon: function () {
                return UnitView.getUnitImage({ code: "kraken", stage: 0 }, { alignAnchorX: true, preferStatic: true });
            }
        },
        quest: {
            type: Map2d.MINE,
            unit: { code: "kraken" },
            monster: "kraken"
        }
    },

    woodgenerator_1: {
        trigger: { unit: { code: "woodgenerator", stage: 0 } },
        tutorial: "woodgenerator_1",
        dynamic: {
            getTitle: function () {
                return Messages.get("Quest.woodgenerator_1.title", {
                    name: cleverapps.unitsLibrary.getUnitName({
                        code: "woodgenerator",
                        stage: 0
                    })
                });
            }
        },
        quest: {
            type: Map2d.MINE,
            unit: { code: "woodgenerator", stage: 0 }
        }
    },

    crystal_use: {
        trigger: { fog: "fog5" },
        highlightTargets: { code: "crystal", stage: 2 },
        tutorial: "crystal_use",
        dynamic: {
            getTitle: function () {
                return Messages.get("Quest.crystal_use.title");
            },
            getIcon: function () {
                return new cc.Sprite(bundles.quest_icons.frames.use_crystal);
            }
        },
        quest: {
            type: Map2d.MERGE,
            unit: { code: "crystal", stage: 3 }
        }
    }
};

const RepeatedQuests = {
    r_collectfruit: {
        dynamic: {
            getTitle: function (unit) {
                return Messages.get("Quest.r_collectfruit.title", { name: cleverapps.unitsLibrary.getFamilyName(unit.code) });
            },
            getUnit: function () {
                const fruits = cleverapps.unitsLibrary.listAvailableByType("fruit");
                const chosen = PseudoRandom.GET().choose(fruits);
                if (chosen) {
                    return { code: chosen, stage: 4 };
                }
            }
        },
        quest: {
            type: Map2d.HARVEST
        }
    },
    r_createfruit: {
        dynamic: {
            getTitle: function (unit) {
                return Messages.get("Quest.r_createfruit.title", { name: cleverapps.unitsLibrary.getFamilyName(unit.code) });
            },
            getUnit: function () {
                const fruits = cleverapps.unitsLibrary.listAvailableByType("fruit");
                const chosen = PseudoRandom.GET().choose(fruits);
                if (chosen) {
                    return { code: chosen, stage: 3 };
                }
            }
        },
        quest: {
            type: Map2d.SPAWN
        }
    },
    r_bonusmerge: {
        dynamic: {
            getTitle: function () {
                return Messages.get("Quest.r_bonusmerge.title");
            },
            getIcon: function () {
                return new cc.Sprite(bundles.quest_icons.frames.bonus_merge);
            }
        },
        quest: {
            type: Map2d.MERGE,
            minUnits: 5
        }
    },
    r_open_freechest: {
        dynamic: {
            getTitle: function (unit) {
                return Messages.get("Quest.r_open_chest.title", { name: cleverapps.unitsLibrary.getFamilyName(unit.code) });
            },
            getIcon: function (unit) {
                return UnitView.getUnitImage(UnitsLibrary.ListByCode(unit.code).pop(), { alignAnchorX: true });
            },
            getFindTargets: function () {
                return ["freechest", "discountshop"];
            }
        },

        quest: {
            type: Map2d.PRIZE_HARVESTED,
            unit: { code: "freechest" }
        }
    },
    r_open_herochest: {
        dynamic: {
            getTitle: function (unit) {
                return Messages.get("Quest.r_open_chest.title", { name: cleverapps.unitsLibrary.getFamilyName(unit.code) });
            },
            getIcon: function (unit) {
                return UnitView.getUnitImage(UnitsLibrary.ListByCode(unit.code).pop(), { alignAnchorX: true });
            },
            filter: function () {
                return cleverapps.unitsLibrary.getCurrentHero() !== undefined;
            },
            getFindTargets: function () {
                return ["herochest", "discountshop"];
            }
        },

        quest: {
            type: Map2d.PRIZE_HARVESTED,
            unit: { code: "herochest" }
        }
    },
    r_open_randomchest: {
        dynamic: {
            getTitle: function (unit) {
                return Messages.get("Quest.r_open_randomchest.title", { name: cleverapps.unitsLibrary.getFamilyName(unit.code) });
            },
            getIcon: function (unit) {
                return UnitView.getUnitImage(UnitsLibrary.ListByCode(unit.code).pop(), { alignAnchorX: true });
            },
            getUnit: function () {
                let chests = cleverapps.unitsLibrary.listAvailableByType("chest");
                const eligible = ["sacks", "woodchest", "stonechest", "wagonchest", "bamboochest", "sapphirechest", "snowchest", "lavachest", "sandchest", "asiachest"];
                chests = cleverapps.intersect(chests, eligible);
                const chosen = PseudoRandom.GET().choose(chests);
                if (chosen) {
                    return { code: chosen };
                }
            },
            getFindTargets: function (unit) {
                switch (unit.code) {
                    case "sacks":
                        return ["discountshop"];
                    case "woodchest": case "stonechest": case "wagonchest": case "bamboochest": case "sapphirechest": case "snowchest": case "lavachest": case "sandchest": case "asiachest": {
                        const resource = unit.code.replace("chest", "");
                        return [`${resource}chest`, `${resource}source`, `${resource}generator`];
                    }
                }
            }
        },
        quest: {
            type: Map2d.PRIZE_HARVESTED
        }
    },
    r_use_randomcastle: {
        dynamic: {
            getTitle: function (unit) {
                const name = cleverapps.unitsLibrary.getUnitName(unit);
                return Messages.get("Quest.r_use_randomcastle.title", { name });
            },
            getIcon: function (unit) {
                return UnitView.getUnitImage(UnitsLibrary.ListByCode(unit.code).pop(), { alignAnchorX: true });
            },
            getUnit: function () {
                const resources = cleverapps.unitsLibrary.listAvailableByType("resource");
                let castles = resources.map((code) => UnitsLibrary.ListByCode(code).pop());
                castles = Map2d.currentMap.listAvailableUnits(castles);
                const chosen = PseudoRandom.GET().choose(castles);
                if (chosen) {
                    return { code: chosen.code, stage: chosen.stage };
                }
            }
        },
        quest: {
            type: Map2d.PRIZE_HARVESTED
        }
    },
    r_use_randommine: {
        dynamic: {
            getTitle: function (unit) {
                return Messages.get("Quest.r_use_randommine.title", { name: cleverapps.unitsLibrary.getFamilyName(unit.code) });
            },
            getIcon: function (unit) {
                const units = UnitsLibrary.ListByCode(unit.code).filter((unit) => cleverapps.unitsLibrary.isOpened(unit));
                return UnitView.getUnitImage(units[units.length - 1] || { code: unit.code, stage: 0 }, { alignAnchorX: true });
            },
            getUnit: function () {
                const generators = Map2d.currentMap.listAvailableUnits({ type: "merge3generator" });
                const chosen = PseudoRandom.GET().choose(generators);
                if (chosen) {
                    return { code: chosen.code };
                }
            }
        },
        quest: {
            type: Map2d.COMPLETE_MINING
        }
    },
    r_builditems: {
        dynamic: {
            getTitle: function () {
                return Messages.get("Quest.r_builditems.title");
            },
            getIcon: function () {
                return new cc.Sprite(bundles.quest_icons.frames.build_object);
            }
        },
        quest: {
            type: Map2d.BUILD,
            unit: { type: "resource" }
        }
    }
};

Object.assign(QuestsConfig.main, RepeatedQuests);

for (let stage = 0; stage < 7; stage++) {
    QuestsConfig.main[`hungrygames_order_${stage}`] = {
        dynamic: {
            filter: function () {
                if (typeof HungryGamesCustomer === "undefined") {
                    return false;
                }
                const mission = HungryGamesCustomer.getMission();
                return Boolean(mission && mission.logic.isRunning() && mission.result === stage);
            },
            getIcon: function () {
                return UnitView.getUnitImage({ code: "hungrygames", stage: 0 }, { alignAnchorX: true, preferStatic: true });
            },
            rowCtor: function (row, options) {
                return new HungryGamesQuestIcon(row, options);
            }
        },
        quest: {
            type: Map2d.EXCHANGE,
            unit: { code: "hungry", stage: 0 },
            prize: { soft: 5 }
        }
    };
}
